const { cELM, getWindowHeight, getAnswerVariableCssClass } = require("../utils");
const Scroller = require("../components/scroller");
const Provider = require("../components/blocks/provider.js");
const Block = require("../components/blocks/index");
const ProgressBar = require("../components/progress-bar");
const Notification = require("../components/notification");
const ScrollNotification = require("../components/scroll-notification");
const Chat = require("../chat");

class MedicationModule {
  constructor(type, value, parentRef) {
    this.type = type;
    this.value = value;
    this.parent = parentRef;
    const cssVariableKey = getAnswerVariableCssClass(value);
    this.elContainer = cELM("div", `component-block module_meds_eng ${cssVariableKey}`);
    this.elContainer.addELM(new Provider({ data: value }));
    this.contentHash = {};
    this.typingIndicator = null;
    this._element = null;
    window.skipMedication = this.skipMedication;
  }

  mapFormat(value) {
    const _self = this;
    const params = { data: value.values, answer: "medication-value" };

    switch (params.data.format) {
      case "medication-list":
        params.data.format = "list";
        params.data.labels = ["medication"];
        params.data.options = {
          selectAll: { label: "Select All" },
          deselectAll: { label: "None" },
          buttonName: "Submit",
          alphabetical: true,
          noneOftheAbove: {label:'None of the above'}
        };
        break;
      case "dosage-list":
        params.data.format = "list";
        params.data.labels = ["medication", "dosage"];
        params.data.options = {
          selectAll: { label: "Select All" },
          deselectAll: { label: "None" },
          buttonName: "Submit",
          alphabetical: true
        };
        break;
      case "frequency-more-singleselect-other":
      case "dosage-singleselect-other":
      case "frequency-singleselect-other":
        params.data.format = "singleselect-other";
        break;
      case "more-medications-yes/no":
        params.data.format = "yes/no";
        break;
      case "autocomplete":
        params.data.format = "autocomplete";
      default:
    }

    params.data.id = (_self.value || {}).id;

    return new Block(params);
  }

  handle(type, value) {
    if (this.typingIndicator) {
      this.elContainer.removeELM(this.typingIndicator);
      this.typingIndicator = null;
    }

    // update progress bar
    if (value.progress) {
      ProgressBar.updateProgress(value.progress);
    }

    const _elm = this.handleOnMessage(value);
    if (!_elm) return;
    this.elContainer.innerHTML = "";
    this.elContainer.addELM(new Provider({ data: value }));
    //add medication list
    const elemsToAdd = [];
    if (
      value.values.medication &&
      value.values.format !== "confirm-medications-yes/no"
    ) {
      elemsToAdd.push(
        this.drawMedications(
          value.values.medication.meds,
          undefined,
          value.values
        )
      );
    }

    //this.elContainer.addELM(_elm);
    elemsToAdd.push(_elm);

    if (
      value.values.medication &&
      value.values.format === "confirm-medications-yes/no"
    ) {
      if (value.values.subtextLabel) {
        const deleteLabel = cELM(
          "div",
          "delete-medications",
          value.values.subtextLabel
        );
        elemsToAdd.push(deleteLabel);
      }
      elemsToAdd.push(
        this.drawMedications(value.values.medication.meds, "confirm")
      );

      const answerYesNo = new Block({
        data: { format: "yes/no", values: value.values.values }
      });

      elemsToAdd.push(answerYesNo);
    }

    for (const addEl of elemsToAdd) {
      this.elContainer.addELM(addEl);
    }

    // add show more button
    this.showMore(_elm.getELM());

    if (value.status !== "typing") {
      Scroller.scrollToElm(_elm, () => {
        _elm.focus();
      });
    }
  }

  handleOnMessage(value) {
    //const data = value.values;
    let component = null;

    if (value.format === "empty") return null;

    let identifier = value.values.id;

    if (identifier.indexOf("/answer") > -1) {
      const idParts = identifier.split("/answer/");

      identifier = idParts[0] + "/" + idParts[1];

      if (this.contentHash[identifier]) {
        //DO NOT ADD/DELETE ANSWERS
      }
    } else if (!this.contentHash[identifier]) {
      component = this.mapFormat(value);
      if (value.status === "typing" || value.id.indexOf("/") === -1) {
        this.typingIndicator = component;
        identsplit = (identifier || "").split("suggestions/");
        identifier = identsplit[0] + identsplit[1];
        component = this.contentHash[identifier][1];
        if (
          value.continue === false &&
          component._option._element.updateSuggestions
        ) {
          this.typingIndicator = null;
          component._option._element.updateSuggestions(
            (value.values || []).suggestions
          );
          return;
        }
      } else {
        this.contentHash[identifier] = [
          Object.keys(this.contentHash).length,
          component
        ];
      }
    } else {
      component = this.contentHash[identifier][1];
      //this.elContainer.removeELM(component);
      this.elContainer.innerHTML = "";
      this.elContainer.addELM(new Provider({ data: value }));
      if (
        value.values &&
        value.values.error &&
        component._option._element.handleOnError
      ) {
        component._option._element.handleOnError(value.values.error);
      }
      component = this.mapFormat(value);

      this.contentHash[identifier] = [
        Object.keys(this.contentHash).length,
        component
      ];
    }

    return component;
  }

  getHTML() {
    return this.elContainer;
  }

  getELM() {
    return this.elContainer;
  }

  clearAfterId(id) {
    const index = this.contentHash[id][0];
    const newHash = {};

    Object.keys(this.contentHash).forEach(key => {
      const ch = this.contentHash[key];
      if (ch[0] >= index) {
        this.elContainer.removeELM(ch[1]);
      } else {
        newHash[key] = ch;
      }
    });

    this.contentHash = newHash;
  }
  showMore(elm) {
    const height = getWindowHeight();
    const bound = elm.getBoundingClientRect();

    if (bound.height > height) {
      ScrollNotification.attachElement(elm);
    }
  }

  scrollToFirstItem() {
    Scroller.scrollToElm(this);
  }

  drawMedications(medications, listFormat, inputValues) {
    if (!listFormat || listFormat !== "confirm") listFormat = "edit";

    const medicationsBl = cELM(
      "div",
      `medications ${listFormat == "edit" ? "defocus" : ""}`
    );
    if (medications) {
      const values = Object.values(medications);
      for (let midx = 0; midx < values.length; midx++) {
        const medication = values[midx];
        const medWrapperDiv = cELM("div", "med");
        const medDiv = cELM("div", "name", medication.name);
        medDiv.setAttribute("title", medication.name);
        const medDosageDiv = cELM("div", "dosage", medication.dosage);
        medDosageDiv.setAttribute("title", medication.dosage);
        const medFreqDiv = cELM(
          "div",
          "frequency",
          medication.timesPerDay ? medication.timesPerDay + "/day" : ""
        );

        medWrapperDiv.addELM(medDiv);
        medWrapperDiv.addELM(medDosageDiv);
        medWrapperDiv.addELM(medFreqDiv);

        if (listFormat === "edit") {
          const editWrapper = cELM("div", "edit-wrapper");
          const editButton = cELM("div", "button edit edit-active", "Edit");
          editButton.value = medication.medication;
          editButton.onclick = this.onEditClicked.bind(this);
          if (medication.medication == inputValues.latestMedication) {
            medicationsBl.addELM(medWrapperDiv);
            if (inputValues.edit && (medication.dosage || medication.timesPerDay)) {
              editWrapper.addELM(editButton);
              medicationsBl.addELM(editWrapper);
            }
          }
        } else if (listFormat === "confirm") {
          const delWrapper = cELM("div", "delete-wrapper");
          const delButton = cELM("div", "button delete", "X");
          delButton.value = medication.medication;
          delButton.onclick = this.onDeleteClicked.bind(this);
          delWrapper.addELM(delButton);

          medWrapperDiv.addELM(delWrapper);
          medicationsBl.addELM(medWrapperDiv);
        }
      }
    }
    return medicationsBl;
  }

  onDeleteClicked(evt) {
    const self = this;
    const element = evt.target;
    const value = element.value;
    confirmPop(
      {
        title: "Delete",
        content: "Are you sure you want to delete this medication?"
      },
      function(isConfirmed) {
        if (isConfirmed) {
          element.setAttribute("disabled", true);
          element.parent;
          element.parentNode.style.display = "none";
          Chat.default.send({ 
            medication: value, 
            action: "startDelete",
            id: (self.value || {}).id 
          });
        } else {
        }
      }
    );
  }

  onEditClicked(evt) {
    const self = this;
    const element = evt.target;
    const value = element.value;
    confirmPop(
      {
        title: "Edit answer?",
        content: "This will delete the last medication."
      },
      function(isConfirmed) {
        if (isConfirmed) {
          element.setAttribute("disabled", true);
          element.parent;
          element.parentNode.style.display = "none";
          Chat.default.send({ 
            medication: value, 
            action: "startEdit",
            id: (self.value || {}).id
          });
        } else {
        }
      }
    );
  }

  skipMedication(e) {
    const self = this;
    Chat.default.send({ 
      action: "skip",
      id: (self.value || {}).id
    });
  }
}

module.exports = MedicationModule;
